// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_f1-3";
export var flatBottomCorners = "_f1-5";
export var productImage = "_f1-0";
export var quantityContainer = "_f1-2";
export var quantityHeader = "_f1-6";
export var tooltip = "_f1-1";
export var wrapAndEllipsesOverflow = "_f1-4";